import { render, staticRenderFns } from "./horarios.vue?vue&type=template&id=402b05b8&scoped=true&"
import script from "./horarios.vue?vue&type=script&lang=js&"
export * from "./horarios.vue?vue&type=script&lang=js&"
import style0 from "./horarios.vue?vue&type=style&index=0&id=402b05b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b05b8",
  null
  
)

export default component.exports